module.exports = __webpack_public_path__ + "img/Syrian Arab Republic.58fd4845.svg";